module.exports = __webpack_public_path__ + "img/icon_pic.05e8636f.png";